export type AddressBookItem = {
  address: string;
  name: string;
  id: string;
};
